import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";
import axios from "../../http/axios";

import Pagination from "../UI/Pagination";
import SearchForm from "../UI/SearchForm";
import TextFields from "../UI/TextFiled";
import SwitchToggle from "../UI/SwitchToggle";
import CheckboxElement from "../UI/Checkbox";
import Dialog from "../UI/Dialog";
import { links } from "../../utils/constants";

import {
  getDrivers,
  editDriver,
  deleteDriver,
  deactivateStatusChangeDialog
} from "../../store/actions";

class DriversList extends Component {
  state = {
    currentPage: 1,
    theCurrentDriverIdWhichStatusToBeChange: null,
    statusToBeChange: null,
    removingDriver: null,
    searchValue: null,
    isEditDialogOpen: false,
    isDeleteDialogOpen: false
  };

  componentDidMount() {
    this.getDriversList();
  }

  getDriversList = () => {
    const page = this.state.currentPage;
    const searchValue = this.state.searchValue;

    this.props.getDrivers(page, searchValue);
  };

  goToDriverPage = id => {
    this.props.history.push(links.driver(id));
  };

  pageChangeHandler = page => {
    this.setState({ currentPage: page.selected + 1 });
    this.props.getDrivers(page.selected + 1, null);
  };

  onChangeDriverStatus = (id, status) => {
    if (this.props.showStatusChangeDialog) {
      this.setState({
        isEditDialogOpen: true,
        theCurrentDriverIdWhichStatusToBeChange: id,
        statusToBeChange: status
      });
    } else {
      this.changeDriverStatus(id, status);
    }
  };

  changeDriverStatus = (driverId, status, values) => {
    if (values && values.showDialog) {
      const id = this.props.adminId;
      this.props.deactivateStatusChangeDialog(id);
    }

    const id = driverId
      ? driverId
      : this.state.theCurrentDriverIdWhichStatusToBeChange;
    const data = {
      is_active: status !== null ? status : this.state.statusToBeChange
    };

    this.props.changeDriverStatus(data, id).then(res => {
      this.props.getDrivers(this.state.currentPage, null);
      this.setState({
        isEditDialogOpen: false,
        theCurrentDriverIdWhichStatusToBeChange: null,
        statusToBeChange: null
      });
    });
  };

  onDeleteDriver = () => {
    this.props.deleteDriver(this.state.removingDriver).then(res => {
      this.getDriversList();
      this.setState({ isDeleteDialogOpen: false, removingDriver: null });
    });
  };

  getCSV = () => {
    axios({
      url: "/drivers/?show_all=true",
      method: "GET",
      headers: {
        Authorization: "JWT " + this.props.token,
        Accept: "text/csv"
      },
      responseType: "blob"
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Drivers.csv");
      link.click();
    });
  };

  onSubmitSearchHandler = searchValue => {
    this.props.getDrivers(this.state.currentPage, searchValue);
  };

  onChangeSearchHandler = () => {};

  render() {
    let driversTable = null;
    const { drivers } = this.props;
    if (drivers) {
      driversTable = drivers.map(driver => {
        const id = driver.id;
        const iqamaSaudiId = driver.driver_iqama_saudi_id;
        const firstName = driver.first_name;
        const lastName = driver.last_name;
        const mobileNumber = driver.mobile_number;
        const workType = driver.work_type === "Full-time" ? "Full " : "Part ";
        const status = driver.is_active;
        return (
          <tr key={driver.id}>
            <td onClick={() => this.goToDriverPage(id)}>{id}</td>
            <td onClick={() => this.goToDriverPage(id)}>{iqamaSaudiId}</td>
            <td onClick={() => this.goToDriverPage(id)} className="underline">
              {firstName}
            </td>
            <td onClick={() => this.goToDriverPage(id)} className="underline">
              {lastName}
            </td>
            <td onClick={() => this.goToDriverPage(id)}>{mobileNumber}</td>
            <td onClick={() => this.goToDriverPage(id)}>
              <strong>{workType}</strong>
              time
            </td>
            <td onClick={() => this.onChangeDriverStatus(id, !status)}>
              <SwitchToggle notForm toggled={status} />
            </td>
            <td>
              <Link to={links.editDriver(id)} className="px-10">
                <i className="fa fa-pencil" />
              </Link>
              <Link
                onClick={() =>
                  this.setState({
                    isDeleteDialogOpen: true,
                    removingDriver: id
                  })
                }
                to="#"
                className="px-10 color-red"
              >
                <i className="fa fa-trash font-md" />
              </Link>
            </td>
          </tr>
        );
      });
    }

    let pagination = null;
    if (this.props.driversPageCount > 1) {
      pagination = (
        <Pagination
          pageChangeHandler={this.pageChangeHandler}
          driversPageCount={this.props.driversPageCount}
        />
      );
    }

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <SearchForm
                onSubmit={this.onSubmitSearchHandler}
                onChange={this.onChangeSearchHandler}
              />

              <div className="col-xs-4 text-center">
                <h1 className="color-grey">Driver</h1>
              </div>

              <div className="col-xs-4 text-right">
                <Link
                  to={links.addDriver()}
                  className="btn filled primary min-180"
                >
                  <i className="fa fa-plus font-sm mr-10" />
                  Add new driver
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <div className="table driversList withHover">
            <table>
              <thead>
                <tr>
                  <th>Driver ID</th>
                  <th>Iqama/Saudi ID</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Mobile Number</th>
                  <th>Full/Part Time</th>
                  <th>Change Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{driversTable}</tbody>
            </table>
            <div className="text-right mt-20">
              <a
                style={{ cursor: "pointer" }}
                className="flex-align-y font-sm w-800"
                onClick={this.getCSV}
              >
                <i className="fa fa-download mr-10" />
                Download Excel File
              </a>
            </div>
            {pagination}
          </div>
        </div>

        <Dialog
          open={this.state.isEditDialogOpen}
          handleClose={() => this.setState({ isEditDialogOpen: false })}
        >
          <Form
            onSubmit={values =>
              this.changeDriverStatus(
                undefined,
                this.state.statusToBeChange,
                values
              )
            }
          >
            {formApi => (
              <form onSubmit={formApi.submitForm}>
                <div className="popup-title">
                  <h2>
                    Are you sure you want to{" "}
                    {this.state.statusToBeChange ? "activate" : "deactivate"}{" "}
                    this driver?
                  </h2>
                </div>
                <div className="popup-body">
                  <CheckboxElement
                    field="showDialog"
                    label="Don't show this message again"
                  />
                </div>
                <div className="popup-meta flex justify-end">
                  <button
                    className="no-style w-600 pointer mx-20"
                    type="button"
                    onClick={() => this.setState({ isEditDialogOpen: false })}
                  >
                    No
                  </button>
                  <button type="submit" className="btn filled primary min-120">
                    Yes
                  </button>
                </div>
              </form>
            )}
          </Form>
          <button
            className="no-style close-btn"
            onClick={() => this.setState({ isEditDialogOpen: false })}
          >
            ×
          </button>
        </Dialog>

        <Dialog
          open={this.state.isDeleteDialogOpen}
          handleClose={() => this.setState({ isDeleteDialogOpen: false })}
        >
          <Form onSubmit={() => this.onDeleteDriver()}>
            {formApi => (
              <form onSubmit={formApi.submitForm}>
                <div className="popup-title">
                  <h2>Are you sure you want to delete this driver?</h2>
                </div>

                <div className="popup-meta flex justify-end">
                  <button
                    className="no-style w-600 pointer mx-20"
                    onClick={() =>
                      this.setState({
                        isDeleteDialogOpen: false,
                        removingDriver: null
                      })
                    }
                  >
                    No
                  </button>
                  <button type="submit" className="btn filled primary min-120">
                    Yes
                  </button>
                </div>
              </form>
            )}
          </Form>
          <button
            className="no-style close-btn"
            onClick={() => this.setState({ isDeleteDialogOpen: false })}
          >
            ×
          </button>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    drivers: state.driver.drivers,
    driversPageCount: state.driver.driversPageCount,
    showStatusChangeDialog: state.auth.showStatusChangeDialog,
    adminId: state.auth.pk,
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDrivers: (page, searchValue) => dispatch(getDrivers(page, searchValue)),
    changeDriverStatus: (data, id) => dispatch(editDriver(data, id)),
    deleteDriver: id => dispatch(deleteDriver(id)),
    deactivateStatusChangeDialog: id =>
      dispatch(deactivateStatusChangeDialog(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriversList);



// WEBPACK FOOTER //
// ./src/components/Driver/DriversList.js